import React from 'react';
import { Card, Box, Stack, Typography, Button } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import TimerIcon from '@mui/icons-material/AccessTimeFilled';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { formatDuration } from "../../utils/formatDuration";

function MetaCard({ lessons, duration, certificateEnabled, accessType }) {
    return (
        <Card
            sx={{
                p: 2,
                pt: 3,
                border: '1px solid #ddd',
                boxShadow: 'none',
                borderRadius: 2,
            }}
        >
            <Stack spacing={2} sx={{ mb: 1 }}>
                {/* Access Type */}
                <Box display="flex" alignItems="center">
                    <LockOpenIcon sx={{ color: 'primary.main', mr: 2 }} />
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {accessType === 'open'
                            ? 'Open to All Registered Users'
                            : accessType === 'invite'
                                ? 'Invite Code is Required'
                                : 'Active Subscription Required'}
                    </Typography>
                </Box>

                {/* Access on Phone and Tablet */}
                <Box display="flex" alignItems="center">
                    <SmartphoneIcon sx={{ color: 'primary.main', mr: 2 }} />
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        Available on Phone and Tablet
                    </Typography>
                </Box>

                {/* Lessons */}
                {lessons > 10 && (
                    <Box display="flex" alignItems="center">
                        <SchoolIcon sx={{ color: 'primary.main', mr: 2 }} />
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {lessons} Lessons
                        </Typography>
                    </Box>
                )}

                {/* Duration */}
                {duration > 60 && (
                    <Box display="flex" alignItems="center">
                        <TimerIcon sx={{ color: 'primary.main', mr: 2 }} />
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {formatDuration(duration)}
                        </Typography>
                    </Box>
                )}

                {/* Certificate */}
                {certificateEnabled && (
                    <Box display="flex" alignItems="center">
                        <EmojiEventsIcon sx={{ color: 'primary.main', mr: 2 }} />
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            Certificate of Completion
                        </Typography>
                    </Box>
                )}
            </Stack>
        </Card>
    );
}

export default MetaCard;
